import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select"; // Import React Select
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExitInformationModal = ({ exitData, onUpdate }) => {
  const [editedData, setEditedData] = useState(exitData);
  const [errors, setErrors] = useState({});
  const submitButtonRef = useRef(null);

  useEffect(() => {
    setEditedData(exitData || {});
  }, [exitData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleSelectChange = (selectedOption, name) => {
    setEditedData({ ...editedData, [name]: selectedOption.value });
  };

  const handleDateChange = (date, name) => {
    setEditedData({ ...editedData, [name]: date });
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!editedData.resignation_date) newErrors.resignation_date = "Resignation date is required";
    if (!editedData.exit_date) newErrors.exit_date = "Exit date is required";
    if (!editedData.last_day_at_work) newErrors.last_day_at_work = "Last day at work is required";
    if (!editedData.reason_for_resignation) newErrors.reason_for_resignation = "Reason for resignation is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      editedData.empstatus="resigned"; 

      onUpdate(editedData);
     // toast.success("Exit information updated successfully!");
      if (submitButtonRef.current) {
        submitButtonRef.current.click();
      }
    } else {
      console.log("Form validation failed");
    }
  };

  // Options for Select components
  const booleanOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  return (
    <div id="exit_info_modal" className="modal custom-modal fade" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "60%" }}>
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">Exit Information</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
            <form onSubmit={handleSubmit}>
              <div className="container">
                <div className="row">
                  {/* Left Column */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Resignation Date <span className="text-danger">*</span></label>
                      <DatePicker
                        selected={editedData.resignation_date ? new Date(editedData.resignation_date) : null}
                        onChange={(date) => handleDateChange(date, "resignation_date")}
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                      />
                      {errors.resignation_date && (
                        <div className="text-danger">{errors.resignation_date}</div>
                      )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">Exit Date <span className="text-danger">*</span></label>
                      <DatePicker
                        selected={editedData.exit_date ? new Date(editedData.exit_date) : null}
                        onChange={(date) => handleDateChange(date, "exit_date")}
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                      />
                      {errors.exit_date && (
                        <div className="text-danger">{errors.exit_date}</div>
                      )}
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">Last Day at Work <span className="text-danger">*</span></label>
                      <DatePicker
                        selected={editedData.last_day_at_work ? new Date(editedData.last_day_at_work) : null}
                        onChange={(date) => handleDateChange(date, "last_day_at_work")}
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                      />
                      {errors.last_day_at_work && (
                        <div className="text-danger">{errors.last_day_at_work}</div>
                      )}
                    </div>
                  </div>
                  {/* Right Column */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Resignation Accepted</label>
                      <Select
                        options={booleanOptions}
                        value={booleanOptions.find(option => option.value === editedData.resignation_accepted)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "resignation_accepted")}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">Notice Served</label>
                      <Select
                        options={booleanOptions}
                        value={booleanOptions.find(option => option.value === editedData.notice_served)}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, "notice_served")}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                    <div className="input-block mb-3">
                      <label className="col-form-label">Reason for Resignation <span className="text-danger">*</span></label>
                      <textarea
                        className="form-control"
                        name="reason_for_resignation"
                        value={editedData.reason_for_resignation}
                        onChange={handleChange}
                      />
                      {errors.reason_for_resignation && (
                        <div className="text-danger">{errors.reason_for_resignation}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-center" style={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                margin: 0,
                display: 'flex',
                justifyContent: 'center',
                padding: '0px',
                width: "60%"
              }}>
                <button type="submit" className="btn btn-primary">Save</button>
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Close</button>
              </div>
            </form>
            <div style={{ display: 'none' }}>
              <button
                ref={submitButtonRef}
                data-bs-dismiss="modal"
                aria-label="Close"
                type="reset"
              >
                Submit2
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitInformationModal;
